import playerjs from 'player.js';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  updateShareVideoIframeLoaded,
  updateShareVideoPlayerReady,
} from 'actions/shareVideo';
import { TARGET_SHARE_PAGE_EMBED_PARAM } from 'constants/oEmbed';
import { EMBED_VIDEO, LOOM_URI } from 'constants/routes';

import EmbedVideo from 'components/embed-video';

import './styles.less';

const MAX_VIDEO_CONTAINER_HEIGHT = 544;
const MIN_VIDEO_CONTAINER_PADDING_BOTTOM = 56.25; // 16:9

// This components acts as a normal video compoennt for the main
// video on the share page video, but an iFrame for embeded if used
// in that manner
class VideoFrame extends Component {
  render() {
    const { isMainVideoOnSharePage, videoId, startTime } = this.props;

    const params = startTime ? `&t=${startTime}` : '';

    // we add an extra param to signify that this video is the main
    // embed on this page. This is because with the loom sdk link expansion
    // loom links in comments etc will turn into embeds and they will try
    // to use the window.parent redux store. This param
    // TARGET_SHARE_PAGE_EMBED_PARAM signals the embedded page to not
    // use the parent store if this is not the main video for that page.
    const embedUrl = `${LOOM_URI}${EMBED_VIDEO}/${videoId}?${TARGET_SHARE_PAGE_EMBED_PARAM}=1${params}`;
    const styles = this.getResponsiveVideoWrapperDimensions();

    let contentContainer;

    if (isMainVideoOnSharePage) {
      contentContainer = (
        <EmbedVideo stylesFromShareVideoParent={{ position: 'absolute' }} />
      );
    } else {
      contentContainer = (
        <iframe
          ref={iframe => (this.videoIframe = iframe)}
          style={styles.iframe}
          src={embedUrl}
          frameBorder="0"
          allowFullScreen
        />
      );
    }

    return (
      <div className="embed-video-frame-wrapper" style={styles.wrapper}>
        <div
          className="embed-video-frame-container"
          ref={container => (this.videoContainer = container)}
          style={styles.container}
        >
          {contentContainer}
        </div>
        {this.props.children}
      </div>
    );
  }

  // to know what's going on here, check this:
  // http://www.goldenapplewebdesign.com/responsive-aspect-ratios-with-pure-css/
  getResponsiveVideoWrapperDimensions() {
    const { videoProperties, iframeVisible, theaterMode } = this.props;
    const styles = { container: {}, wrapper: {}, iframe: {} };

    if (!videoProperties) {
      return styles;
    }

    const { width, height } = videoProperties || {};

    if (!width || !height || !this.videoContainer) {
      return styles;
    }

    const maxContainerWidth = this.videoContainer.offsetWidth;
    const unboundPadding = height / width;
    const unboundHeight = unboundPadding * maxContainerWidth;
    const boundHeight = Math.min(unboundHeight, MAX_VIDEO_CONTAINER_HEIGHT);
    const boundPadding = boundHeight / maxContainerWidth;
    const boundPaddingPercentage = boundPadding * 100;

    let paddingBottomValue = boundPaddingPercentage;

    if (
      !theaterMode &&
      boundPaddingPercentage < MIN_VIDEO_CONTAINER_PADDING_BOTTOM
    ) {
      paddingBottomValue = MIN_VIDEO_CONTAINER_PADDING_BOTTOM;
    }

    // enforce minimum aspect ratio of 16:9 for super wide videos
    styles.container.paddingBottom = `${paddingBottomValue}%`;
    styles.wrapper.minHeight = 'auto';
    !iframeVisible && (styles.iframe.visibility = 'hidden');

    return styles;
  }

  componentDidMount() {
    const { isMainVideoOnSharePage } = this.props;

    if (isMainVideoOnSharePage) {
      return;
    }

    const player = playerjs.Player(this.videoIframe);

    player.on('ready', () => {
      this.props.updateShareVideoPlayerReady(true);
    });
    this.videoIframe.onload = () => {
      this.props.updateShareVideoIframeLoaded(true);
    };
  }
}

const mapStateToProps = state => {
  const { video, iframe_visible: iframeVisible } = state.share_video;
  const {
    isMainVideoOnSharePage,
    theater_mode: theaterMode,
  } = state.video_player;

  return {
    iframeVisible,
    videoProperties: (video || {}).video_properties,
    isMainVideoOnSharePage,
    theaterMode,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateShareVideoIframeLoaded: loaded =>
      dispatch(updateShareVideoIframeLoaded(loaded)),
    updateShareVideoPlayerReady: playerReady =>
      dispatch(updateShareVideoPlayerReady(playerReady)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoFrame);
